import * as React from "react";

import { Button } from "semantic-ui-react";

import { ActionableTask } from "../models";

import { Link } from "redux-little-router";

export const EmployeeViewSraResults = (task: ActionableTask) => {
    if (task.completed || task.cancelled) {
        return null;
    }

    return (
        <Link href={`/actions/customer/${task.customerId}/ohCase/${task.ohCaseId}/stressriskassessmentresults`}>
            <Button secondary content="View" />
        </Link>
    );
};
